import { render, staticRenderFns } from "./PayrollGroupNew.vue?vue&type=template&id=9498006a"
import script from "./PayrollGroupNew.vue?vue&type=script&lang=js"
export * from "./PayrollGroupNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports